module.exports = __webpack_public_path__ + "static/media/store-1.03809454.svg";